export function isOrderExpired(time: number) {
  // Convert time to milliseconds and add 30 minutes (30 * 60 * 1000 milliseconds)
  const orderPlacedTimePlus30min = time * 1000 + 30 * 60 * 1000;
  const currentTime = Date.now();
  return orderPlacedTimePlus30min > currentTime;
}
